import { render, staticRenderFns } from "./ImageInputChoice.vue?vue&type=template&id=f1862442&"
import script from "./ImageInputChoice.vue?vue&type=script&lang=js&"
export * from "./ImageInputChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports